import React from 'react';
import CardCarouselControls from './CardCarouselControls';

interface CardCarouselWrapperProps {
  children: React.ReactNode;
  cardDimension: number;
  elementsToShow: number;
}

/**
 *
 *@params
 *children carousel elements
 *cardDimension width of one element,
 *elementsToShow elements in the view,
 */
export function CardCarouselWrapper({
  children,
  cardDimension,
  elementsToShow,
}: CardCarouselWrapperProps) {
  const carousel = React.useRef<HTMLDivElement>(null);

  const [styles, setStyles] = React.useState({
    width: `${elementsToShow * cardDimension}px`,
    scrollSnapType: 'x mandatory',
    scrollPadding: '0%',
  });

  React.useEffect(
    function syncStyles() {
      setStyles({
        width: `${elementsToShow * cardDimension}px`,
        scrollSnapType: 'x mandatory',
        scrollPadding: '0%',
      });
    },
    [elementsToShow, cardDimension]
  );

  const scroll = (direction: 'left' | 'right') => {
    carousel?.current?.scrollTo({
      top: 0,
      left:
        direction === 'left'
          ? (carousel?.current?.scrollLeft ?? 0) - cardDimension
          : (carousel?.current?.scrollLeft ?? 0) + cardDimension,
      behavior: 'smooth',
    });
  };

  return (
    <div className="w-full mt-5 relative flex justify-center ">
      <CardCarouselControls scroll={scroll} />
      <div
        ref={carousel}
        className="hide-scrollbar w-full flex relative overflow-x-scroll  z-0 items-center"
        style={styles}
      >
        {children}
      </div>
    </div>
  );
}

export default CardCarouselWrapper;
